import { render, staticRenderFns } from "./CustomFieldsPanel.vue?vue&type=template&id=80cc4fc8&scoped=true&lang=pug&"
import script from "./CustomFieldsPanel.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsPanel.vue?vue&type=style&index=0&id=80cc4fc8&lang=stylus&scoped=true&"
import style1 from "./CustomFieldsPanel.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cc4fc8",
  null
  
)

export default component.exports